import PropTypes from 'prop-types';

export const ServiceDetailPropType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    priceUnit: PropTypes.string.isRequired,
    location: PropTypes.string,
    businessType: PropTypes.string,
    images: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            mediaUrl: PropTypes.string,
            metadata: PropTypes.string
        })
    ),
    wishlistId: PropTypes.string,
    badges: PropTypes.shape({
        isNewService: PropTypes.bool,
        isTopRated: PropTypes.bool,
        isPromoted: PropTypes.bool
    }),
    isFavorited: PropTypes.bool,
    ratings: PropTypes.number,
    ratingsCount: PropTypes.number,
    seller: PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
        businessName: PropTypes.string.isRequired,
        imageUrl: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        badges: PropTypes.shape({
            isShowBCAAMember: PropTypes.bool
        }),
        verifications: PropTypes.shape({
            isCriminalRecordVerified: PropTypes.bool,
            isGovIdVerified: PropTypes.bool
        }),
        // Future ticket
        documents: PropTypes.any
    })
});
